export default __webpack_public_path__ + "static/media/guideline_4.48df7233.svg";